import { useApi } from '@/composables/useApi'

const api = useApi()

// eslint-disable-next-line import/prefer-default-export
export function ModuloService() {
  this.getModulos = function () {
    return new Promise((resolve, reject) => {
      try {
        api.get('/getModulo')
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.getModuloConteudoById = function (idModelo) {
    return new Promise(async (resolve, reject) => {
      try {
        await api.get(`/getModuloConteudoById?id_modulo=${idModelo}`)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.getModuloById = function (id) {
    return new Promise((resolve, reject) => {
      try {
        api.get(`/getModuloById/${id}`)
          .then(res => {
            resolve(res.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.UpdateModulo = function (id, params) {
    return new Promise((resolve, reject) => {
      try {
        api.put(`/updateModulo/${id}`, params)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
